// extracted by mini-css-extract-plugin
export var ctaSection = "StartJourney-module--ctaSection--AFXTr";
export var featuredWrapper = "StartJourney-module--featuredWrapper--CGgIO";
export var startJourney_content = "StartJourney-module--startJourney_content--pyIJd";